export enum OnboardingMilestoneTag {
  INTRO = 'intro',
  HR_PRACTICE = 'hr-practice',
}

export default null;
